/**
 * src/index.ts
 * Ponto de entrada da aplicação (Entrypoint).
 * Inicializa o monitoramento do DOM e expõe a API global.
 */

import { startObserver } from './utils/mutation-observer';
import { CenarioEngine } from './ui/cenario';

const isDebugMode = import.meta.env.DEV || window.location.hostname.includes('localhost');

if (isDebugMode) {
  void import('./dev/json-hmr');
}

// Extensão segura do objeto Window para debug
declare global {
  interface Window {
    CenarioEngine?: typeof CenarioEngine;
  }
}
declare const __APP_VERSION__: string;

// Inicia automaticamente ao carregar o script
if (typeof window !== 'undefined') {
  // Aguarda o DOM estar pronto (caso o script esteja no <head>)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  // Expor globalmente para Debug manual ou chamadas via console
  window.CenarioEngine = CenarioEngine;
}

console.warn(`[CenarioMap] Bundle carregado. Versão: ${__APP_VERSION__ || 'Dev'}`);
